import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Text } from '@stepstone-genesis/components';
export const ContentHeading = ({ label }) => {
    return (_jsx(Text, { as: 'h2', size: ['xl', 'xxl'], fontWeight: 'fontWeightBold', lineHeight: ['lineHeightXl', 'lineHeightXxl'], children: label }));
};
//# sourceMappingURL=ContentHeading.js.map